import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { environment } from '../../../environments/environment';
import { StorageService } from 'core-lib';
import { forkJoin } from 'rxjs';

@Component({
    selector: 'app-clearcache',
    imports: [],
    templateUrl: './clearcache.component.html',
    styleUrl: './clearcache.component.scss'
})
export class ClearcacheComponent implements OnInit {

  cacheSuccess:boolean = false;
  paymentCacheSuccess:boolean = false;

  constructor(
    private http: HttpClient,
    private storageService: StorageService
  ) {}

  ngOnInit() {
    
    // inside your function
    forkJoin({
      cache: this.http.delete(`${environment.backendHost}/api/content/cache`, {
        responseType: 'text',
        observe: 'response'
      }),
      payment: this.http.delete(`${environment.paymentEndpoint}/api/Payments/cache`, {
        responseType: 'text',
        observe: 'response'
      })
    }).subscribe({
      next: (results) => {
        // results.cache → Response from first call
        // results.payment → Response from second call

        this.cacheSuccess = results.cache.status === 200;
        this.paymentCacheSuccess = results.payment.status === 200;

      },
      error: (err) => {
        console.error('One of the requests failed:', err);
      },
      complete: () => {
        this.enableRedirect();
      }
    });

    this.storageService.clearAllStorage();
  }

  enableRedirect() {
    setTimeout(() => {
      window.location.href = '/home';
    }, 3000);
  }
}
